import React, { useEffect, useRef, useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../../../../layout/Content'
import ModalWindow from '../../../../../layout/modalwindow/ModalWindow'
import AdminConfigStyle from './css/AdminConfigStyle'
import { adminConfigControllerContext } from './AdminConfigController'

function AdminConfig(props) {
  const adminConfigController = useContext(adminConfigControllerContext)
  let [client, setClient] = adminConfigController.client
  const { updateClient, app_client, countries, time_zones } = adminConfigController
  const [edit, setEdit] = useState(false)
  const [newAdminPassword, setNewAdminPassword] = useState(
    {
      current_admin_password: '',
      new_admin_password: '',
      confirm_new_admin_password: ''
    }
  )
  const [changePassword, setChangePassword] = useState(false)
  // const [error, setError] = useState({ group: '', id: '', message: '' })
  const [error, setError] = useState(null)
  const ceoRef = useRef(null)
  const currentAdminPasswordRef = useRef(null)

  /*** Control's Enabler functions *********/
  // Left wrapper
  const enableLeftWrapper = () => {
    // Enable left wrapper inputs
    const left_wrapper_input = document.querySelector('.left-wrapper').querySelectorAll('input')
    left_wrapper_input.forEach((input, i) => {
      input.removeAttribute('readonly')
      input.classList.remove('read-only')
    })

    // Select control
    const left_wrapper_select = document.querySelector('.left-wrapper').querySelectorAll('select')
    left_wrapper_select.forEach((select, i) => {
      select.removeAttribute('readonly')
      select.classList.remove('read-only')
    })
  }

  /*** Control's Disabler Functions ***********/
  // Left wrapper
  const disableLeftWrapper = () => {
    // Disable left wrapper inputs
    const left_wrapper_input = document.querySelector('.left-wrapper').querySelectorAll('input')
    left_wrapper_input.forEach((input, i) => {
      input.setAttribute('readonly', 'true')
      input.classList.add('read-only')
    })

    // Select control
    const left_wrapper_select = document.querySelector('.left-wrapper').querySelectorAll('select')
    left_wrapper_select.forEach((select, i) => {
      select.setAttribute('readonly', 'true')
      select.classList.add('read-only')
    })
  }

  // Changes will be realized on the next log-in
  const onClickSave = (e) => {
    const showSuccessMessageBox = () => {
      ReactDOM.render(
        <ModalWindow
          id='mw-parent'
          width='50'
          height='35'
          header="Update User Account"
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content' style={{fontSize: '1.2rem'}}>
                <p>{`These changes will take effect only on the next login for those users who are currently online rightnow.`}</p>
                <br />
                <p>However, some changes will also take it's effect immediately for the user who executed the update.</p>
                <br />
              </div>
              <div className='button-container'>
                <button
                  onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))}}
                  className='pospro-action-btn top-anchor'>Ok</button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const showConfirmUpdateMessageBox = () => {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          header='Confirm Update/Changes'
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content' style={{fontSize: '1.2rem'}}>
                <p>{`Are you sure you want to make the changes?`}</p>
                <br />
              </div>
              <div className='button-container'>
                <button
                  onClick={() => { ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))}}
                  className='pospro-action-btn top-anchor'>No</button>
                <button
                  onClick={async () => { 
                    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
                    await proceedSaveClient()
                  }}
                className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    const proceedSaveClient = async () => {
      if (changePassword) {
        client = {
          ...client,
          admin_login_details: {
            ...client.admin_login_details,
            current_password: newAdminPassword.current_admin_password,
            new_password: newAdminPassword.new_admin_password,
            confirm_new_password: newAdminPassword.confirm_new_admin_password
          }
        }
      }

      const updated_client = await updateClient(client)
      if (updated_client.error) {
        setError(updated_client.error)
      } else {
        setEdit(false)
        setNewAdminPassword({ current_admin_password: '', new_admin_password: '', confirm_new_admin_password: '' })
        setError(null)
        setChangePassword(false)
        showSuccessMessageBox()
      }
    }

    if (edit) showConfirmUpdateMessageBox()
    else proceedSaveClient()
  }

  const onClickCancel = (e) => {
    setEdit(false)
    setChangePassword(false)
    setError(null)

    setClient({ ...app_client })
  }

  const onChangeCompanyProfile = (e) => {
    setClient({...client, company_profile: { ...client.company_profile, [e.target.id]: e.target.value }})
  }

  const onChangeCompanyAddress = (e) => {
    setClient({...client, company_address: { ...client.company_address, [e.target.id]: e.target.value }})
  }

  const onChangeAdminLoginDetails = (e) => {
    setClient({...client, admin_login_details: { ...client.admin_login_details, [e.target.id]: e.target.value }})
  }

  const onClickChangePassword = (e) => { setChangePassword(true) }

  useEffect(() => {
    if (edit) {
      enableLeftWrapper()
      ceoRef.current.focus()
    } else disableLeftWrapper()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit])

  useEffect(() => {
    if (error?.ceo) document.getElementById('ceo').focus()
    else if (error?.company_name) document.getElementById('company_name').focus()
    else if (error?.email) document.getElementById('email').focus()
    else if (error?.user_name) document.getElementById('user_name').focus()
    else if (error?.current_password) document.getElementById('current_password').focus()
    else if (error?.new_password) document.getElementById('new_password').focus()
    else if (error?.confirm_new_password) document.getElementById('confirm_new_password').focus()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    disableLeftWrapper()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ContentInner>
      <div className='admin-config-container'>
        <div className='left-wrapper'>
          {/*** Company Profile ***/}
          <div className='control-wrapper'>
            <div className='control-header-title'>Company Profile</div>
            <div className='fields-container'>
              <input
                id='ceo'
                ref={ceoRef}
                value={client.company_profile.ceo}
                onChange={onChangeCompanyProfile}
                placeholder='C.E.O.'
                type='text'
              />
              <div className={error?.ceo ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.ceo ? error.ceo[0] : null}
              </div>
              <input
                id='company_name'
                value={client.company_profile.company_name}
                onChange={onChangeCompanyProfile}
                placeholder='Company Name'
                type='text'
              />
              <div className={error?.company_name ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.company_name ? error.company_name[0] : null}
              </div>
              <input
                id='email'
                value={client.company_profile.email}
                onChange={onChangeCompanyProfile}
                placeholder='Email'
                type='text'
              />
              <div className={error?.email ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                {error?.email ? error.email[0] : null}
              </div>
              <input
                id='contact_number'
                value={client.company_profile.contact_number}
                onChange={onChangeCompanyProfile}
                placeholder='Contact Number'
                type='text'
              />
              <input
                id='tin'
                value={client.company_profile.tin}
                onChange={onChangeCompanyProfile}
                placeholder='T.I.N.'
                type='text'
              />
            </div>
          </div>

          {/*** Company Address ***/}
          <div className='control-wrapper'>
            <div className='control-header-title'>Company Address</div>
            <div className='fields-container'>
              <input
                id='street'
                value={client.company_address.street}
                onChange={onChangeCompanyAddress}
                placeholder='Street, house #, building #, etc..'
                type='text'
              />
              <input
                id='city'
                value={client.company_address.city}
                onChange={onChangeCompanyAddress}
                placeholder='City'
                type='text'
              />
              <input
                id='zip_code'
                value={client.company_address.zip_code}
                onChange={onChangeCompanyAddress}
                placeholder='ZIP/Postal Code'
                type='text'
              />
              <input
                id='state'
                value={client.company_address.state}
                onChange={onChangeCompanyAddress}
                placeholder='State, Province, Region'
                type='text'
              />
              <select
                id='country'
                placeholder='Country'
                onChange={onChangeCompanyAddress}
                value={client.company_address.country}>
                { countries.map((country, index) => ( <option key={index}>{country}</option> )) }
              </select>
              <select
                id='time_zone'
                type='text'
                placeholder='Timezone'
                value={client.company_address.time_zone}
                onChange={(e) => { setClient({ ...client, compay_address: { ...client.company_address,  time_zone: e.target.value } }) }}>
                { time_zones.map((tz, i) => ( <option key={i}>{tz}</option> )) }
              </select>
            </div>
          </div>

          {/*** Login Details ***/}
          <div className='control-wrapper'>
            <div className='control-header-title'>Admin Login Details</div>
            <div className='fields-container'>
              <input
                id='user_name'
                value={client.admin_login_details.user_name}
                onChange={onChangeAdminLoginDetails}
                placeholder='Admin Username'
                type='text'
              />
              <div className={error?.user_name ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                { error?.user_name ? error?.user_name[0] : null }
              </div>
              <input
                id='current_password'
                ref={currentAdminPasswordRef}
                value={newAdminPassword.current_admin_password}
                onChange={(e) => { setNewAdminPassword({...newAdminPassword, current_admin_password: e.target.value}) }}
                placeholder='Current Admin Password (required)'
                type='password'
                style={{display: (changePassword) ? 'block' : 'none'}}
              />
              <div className={error?.current_password ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                { error?.current_password ? error?.current_password[0] : null }
              </div>
              <input
                id='new_password'
                value={newAdminPassword.new_admin_password}
                onChange={(e) => { setNewAdminPassword({...newAdminPassword, new_admin_password: e.target.value}) }}
                placeholder='New Admin Password (required)'
                type='password'
                style={{display: (changePassword) ? 'block' : 'none'}}
              />
              <div className={error?.new_password ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                { error?.new_password ? error?.new_password[0] : null }
              </div>
              <input
                id='confirm_new_password'
                value={newAdminPassword.confirm_new_admin_password || ''}
                onChange={(e) => { setNewAdminPassword({...newAdminPassword, confirm_new_admin_password: e.target.value}) }}
                placeholder='Confirm New Admin Password (required)'
                type='password'
                style={{display: (changePassword) ? 'block' : 'none'}}
              />
              <div className={error?.confirm_new_password ? 'error-notification' : 'hide-fc'}>
                <FontAwesomeIcon icon='exclamation-circle' />&nbsp;
                { error?.confirm_new_password ? error?.confirm_new_password[0] : null }
              </div>
              <div className='change-password-group-button'>
                <button
                  id='change-user-password'
                  disabled={!edit}
                  onClick={onClickChangePassword}
                  className='change-user-password'
                  style={{display: (changePassword) ? 'none' : 'block'}}>
                  Change Password
                </button>
              </div>
            </div>
          </div>

          {/*** Action Buttons ***/}
          <hr />
          <div className='action-button-container'>
            <div className={(edit) ? 'hide-fc' : 'aed-button-group'}>
              <button
                id='edit-btn'
                onClick={() => { setEdit(true) }}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='edit'/>&nbsp;
                Edit
              </button>
            </div>
            <div className={(edit) ? 'cs-button-group' : 'hide-fc'}>
              <button
                id='cancel-btn'
                onClick={onClickCancel}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='undo'/>&nbsp;
                Cancel
              </button>
              <button
                id='save-btn'
                onClick={onClickSave}
                className='pospro-action-btn'>
                <FontAwesomeIcon icon='save'/>&nbsp;
                Save
              </button>
            </div>
          </div>
        </div>
        <div className='right-wrapper'>
        </div>
      </div>
      <AdminConfigStyle />
    </ContentInner>
  )
}

export default React.memo(AdminConfig)